var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRightChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 4 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Down chevron")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Create-Time-Hierarchy-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Show-Hierarchy-Entry-Point",
  transform: "translate(-168.000000, -554.000000)",
  stroke: "#81848F"
}, /*#__PURE__*/React.createElement("g", {
  id: "Drop-down-menu",
  transform: "translate(38.000000, 525.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Down-chevron"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(132.125000, 32.875000) rotate(-90.000000) translate(-132.125000, -32.875000) translate(129.125000, 30.875000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 3 3.75",
  id: "Path-79"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3 0 3 3.75",
  id: "Path-79",
  transform: "translate(4.500000, 1.875000) scale(-1, 1) translate(-4.500000, -1.875000) "
}))))))));
export default SvgIconRightChevron;